import { render, staticRenderFns } from "./BlogCoverPreview.vue?vue&type=template&id=238a77a7&scoped=true&"
import script from "./BlogCoverPreview.vue?vue&type=script&lang=js&"
export * from "./BlogCoverPreview.vue?vue&type=script&lang=js&"
import style0 from "./BlogCoverPreview.vue?vue&type=style&index=0&id=238a77a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238a77a7",
  null
  
)

export default component.exports